import { ReactNode } from 'react';
import { Box, Text, Image } from '@mantine/core';
import classes from './AddFiltersButton.module.css';
import PlusIcon from '@assets/icons/plus.svg';

export const AddFiltersButton = (props: {
	children: ReactNode;
	onClick?: () => void;
}) => {
	return (
		<Box
			onClick={props.onClick}
			className={classes.addFilter}
		>
			<Image
				className={classes.iconAddFilter}
				src={PlusIcon}
			/>
			<Box className={classes.spacerFilterBtn} />
			<Text className={classes.addFilterText}>
				{props.children}
			</Text>
		</Box>
	);
};
